<footer>
        <!-- Footer Infos -->
        <div class="container-fluid footerInfos py-3">
          <div class="container-fluid container-lg">
            <div class="row">
              <div class="col-md-4 col-12 mb-3 mb-md-0 text-center text-md-start coordData">
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-lg-2 mb-2 mb-lg-0">
                    <img src="assets/front/images/phone.svg" class="img-fluid" alt="">
                  </div>
                  <div class="col-12 col-lg-10">
                    <p class="infoTitre">APPELEZ-NOUS DÈS MAINTENANT</p>
                    <a href="tel:+212522508060" class="infoContent">+212 522 508 060</a>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12 mb-3 mb-md-0 text-center text-md-start coordData">
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-lg-2 mb-2 mb-lg-0">
                    <img src="assets/front/images/email.svg" class="img-fluid" alt="">
                  </div>
                  <div class="col-12 col-lg-10">
                    <p class="infoTitre">ENVOYEZ-NOUS UN E-MAIL</p>
                    <a href="mailto:info@ceratube.ma" class="infoContent">info@ceratube.ma</a>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12 mb-3 mb-md-0 text-center text-md-start">
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-lg-2 mb-2 mb-lg-0">
                    <img src="assets/front/images/whatsapp.svg" class="img-fluid" alt="">
                  </div>
                  <div class="col-12 col-lg-10">
                    <p class="infoTitre">CONTACTEZ-NOUS VIA WHATSAPP</p>
                    <a href="https://wa.me/212661171546" class="infoContent"> +212 6 61 17 15 46</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Footer Infos -->
        <!-- Footer Content -->
        <div class="container-fluid contentFooter py-3">
          <div class="container ">
            <div class="row d-flex align-items-center">
              <div class="col-12 col-lg-3">
                <img src="assets/front/images/logoblanc.svg" alt="" style="width:120px;">
              </div>
              <div class="col-12 col-lg-4 m txtNewsletter">
                <p>Inscrivez-vous à notre newsletter</p>
                <p>et recevez nos dernières offres</p>
              </div>
              <div class="col-12 col-lg-5 mt-3 mt-lg-0 newsletterForm">
                <form class="newsletter" action="index.html" method="post">
                  <input type="email" name="" value="">
                  <button type="submit" name="button">></button>
                </form>
              </div>
              <div class="col-sm-12 my-3">
                <div class="dividFooter"></div>
              </div>

              <div class="row">
                <div class="col-sm-3">
                  <div class="footerTitre">
                    CONTACTEZ-NOUS
                  </div>
                  <div class="footerData">
                    <p><a href="#"><i class="fa fa-phone" aria-hidden="true"></i>+212 522 508 060</a></p>
                    <!-- <p><a href="#"><i class="fa fa-phone" aria-hidden="true"></i>+212 523 265 100</a></p> -->
                    <p><a href="#"><i class="fa fa-envelope-o" aria-hidden="true"></i> info@ceratube.ma</a></p>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="footerTitre">
                    ASSISTANCE
                  </div>
                  <div class="footerData">
                    <ul>
                      <li><a>Rechercher</a></li>
                      <li><a>SAV</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="footerTitre">
                    LIENS UTILES
                  </div>
                  <div class="footerData">
                    <ul>
                      <li><a routerLink="/apropos">Ceratube</a></li>
                      <li><a routerLink="/inspiration">Inspirations</a></li>
                      <li><a routerLink="/robimeds">Robimed</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="footerTitre">
                    INFORMATIONS
                  </div>
                  <div class="footerData">
                    <ul>
                      <li><a routerLink="/contact">Contactez-nous</a></li>
                      <li><a>Politique de confidentialité</a></li>
                      <li><a routerLink="/cgv">Conditions générales de vente</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Footer Content -->
        <!-- Footer Copyright -->
        <div class="container-fluid footerCopyright py-3 text-center">
          <p>Copyright © Ceratube</p>
        </div>
        <!-- Fin Footer Copyright -->
      </footer>
      <!-- Fin Footer -->
      <!-- Retourner en haut -->
      <a href="#" id="toTopBtn" class="cd-top text-replace js-cd-top cd-top--is-visible cd-top--fade-out" data-abc="true" style="display:none;"></a>
      <!-- Retourner en haut -->
      <!-- Whatsapp Flotant -->
      <div class="floatWhatsapp">
        <a href="https://wa.me/212661171546"><img src="assets/front/images/whatsappfloat.png" alt="whatsapp" width="180px"></a>
      </div>
      <!-- Fin Whatsapp Flotant -->
    <!-- Body content FIN -->
    <!-- Modal -->
    <!-- <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modalDimension modal-dialog modal-dialog-centered">
        <div class="nlModal modal-content">
          <div class="modal-body py-5">
            <div class="row mt-3">
              <div class="col-sm-12 text-end">
                <button type="button" class="nlClose" data-bs-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="modalNlTitre">
                  INSCRIVEZ-VOUS À NOTRE NEWSLETTER
                </div>
                <div class="dividModalNl my-2"></div>
                <div class="sousTitreNlPopup mb-5">
                  Et recevez nos dernières offres!
                </div>
                <div class="col-sm-12 mb-3">
                  <input type="text" name="email" value="" class="emailNl" placeholder="ADRESSE E-MAIL">
                  <button class="btnSubmitNl" type="button" name="button">></button>
                </div>
                <div class="col-sm-12 noPopupNl">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"> Ne plus afficher cette fenêtre
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
